module.exports = __webpack_public_path__ + "img/userbig.3936ed15.png";